import React from 'react';

class AisonoFieldset extends React.Component {
    static defaultProps={
        required:false
    };
    fieldsetStyle = {
        padding: '.35em .625em .75em',
        margin: '3px',
        border: '1px solid silver'
    };

    legendStyle = {
        padding: '.5em',
        border: 0,
        width: 'auto'
    };


    render() {
        let FieldsetContent ;
        if(typeof this.props.content ==='function'){
            FieldsetContent=this.props.content;
        }
        return (
            <fieldset style={this.fieldsetStyle}>
                {this.props.title?<legend style={this.legendStyle}>{this.props.title}<span style={{color:"red"}}>{this.props.required?"*":""}</span></legend>:""}
                {typeof this.props.content ==='function'?<FieldsetContent/>:this.props.content}
            </fieldset>
        );
    }
}

export default AisonoFieldset;
